export const ERROR_NOTIFICATION_TYPES = Object.freeze({
  FormNavigator: 'FormNavigator',
  Descriptor: 'Descriptor',
});

export type ErrorNotificationType = typeof ERROR_NOTIFICATION_TYPES[keyof typeof ERROR_NOTIFICATION_TYPES];